import { render, staticRenderFns } from "./FieldActionButton.vue?vue&type=template&id=508b7ee7&"
import script from "./FieldActionButton.vue?vue&type=script&lang=ts&"
export * from "./FieldActionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports